require('./angular-cookies');
module.exports = 'ngCookies';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-cookies/index.js
 ** module id = 274
 ** module chunks = 0
 **/